export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/teal-badge.fd584022.svg","height":199,"width":207};